'use client'

import { Button } from '@nextui-org/button'

import { Link } from '@/libs/intl'

import '@/styles/pages/not_found.scss'

export default function NotFound() {
  // __RENDER
  return (
    <main className='not-found' aria-labelledby='not-found-title'>
      <section className='not-found__container'>
        <h1 id='not-found-title' className='not-found__code'>
          404
        </h1>
        <h2 className='not-found__headline'>Oops, this page not found!</h2>
        <p className='not-found__desc'>The link might be corrupted</p>
        <p className='not-found__desc not-found__desc--muted'>or the page may have been removed.</p>
        <div className='not-found__actions'>
          <Button className='not-found__button' as={Link} href='/' color='primary' radius='sm'>
            Go back home
          </Button>
        </div>
      </section>
    </main>
  )
}
